import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useMusicPlayer } from "@/context/MusicPlayerContext";
import { useI18n } from "@/context/I18n";
import { toast } from "sonner";
import { Loader2, Play, Sparkles, Radio } from "lucide-react";

const SUB_MAP = {
  "Basado en tus gustos": "sub_taste", "Tu mezcla diaria": "sub_daily",
  "Descubre": "sub_discover", "Para empezar": "sub_start",
};

export default function ForYou() {
  const [mixes, setMixes] = useState(null);
  const { playQueue, setRadio } = useMusicPlayer();
  const { t } = useI18n();

  useEffect(() => {
    api.get("/music/for-you").then((r) => setMixes(r.data.mixes)).catch(() => setMixes([]));
  }, []);

  const playMix = (m, radio) => {
    if (!m.tracks || !m.tracks.length) return;
    if (setRadio) setRadio(!!radio);
    playQueue(m.tracks, 0);
    toast.success(radio ? t("radio_on") : m.title);
  };

  return (
    <div className="p-4 md:p-8 pb-6" data-testid="for-you-page">
      <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#FF2A4D]">{t("made_for_you")}</p>
      <h1 className="font-heading text-3xl font-bold tracking-tight mt-1 mb-6">{t("made_for_you")}</h1>

      {mixes === null ? (
        <div className="py-16 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-zinc-500" /></div>
      ) : mixes.length === 0 ? (
        <p className="text-zinc-500 text-sm py-10 text-center">{t("catalog_empty_d")}</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {mixes.map((m) => (
            <div key={m.id} data-testid={`foryou-mix-${m.id}`} className="bg-white/5 hover:bg-white/10 rounded-xl p-4 transition-colors group flex gap-4">
              <div className="relative shrink-0">
                {m.cover ? <img src={m.cover} alt="" className="w-24 h-24 rounded-lg object-cover" /> : <div className="w-24 h-24 rounded-lg bg-white/10 flex items-center justify-center"><Sparkles className="w-8 h-8 text-zinc-500" /></div>}
              </div>
              <div className="flex-1 min-w-0 flex flex-col">
                <p className="font-semibold truncate">{m.title}</p>
                <p className="text-xs text-zinc-400 truncate">{SUB_MAP[m.subtitle] ? t(SUB_MAP[m.subtitle]) : m.subtitle} · {m.tracks.length} {t("tracks")}</p>
                <div className="mt-auto flex items-center gap-2 pt-2">
                  <button data-testid={`foryou-play-${m.id}`} onClick={() => playMix(m, false)} className="w-9 h-9 rounded-full bg-[#FF2A4D] hover:bg-[#E61C3D] flex items-center justify-center transition-colors">
                    <Play className="w-4 h-4 text-white ml-0.5" fill="white" />
                  </button>
                  <button data-testid={`foryou-radio-${m.id}`} onClick={() => playMix(m, true)} title={t("radio")} className="w-9 h-9 rounded-full border border-white/20 hover:border-white/50 flex items-center justify-center transition-colors">
                    <Radio className="w-4 h-4" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
